module.exports = __webpack_public_path__ + "assets/img/2815.e77cdc5d.png";